/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height (cm)`)
};

const es_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const de_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe (cm)`)
};

const nl_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengte (cm)`)
};

const fr_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (cm)`)
};

const it_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza (cm)`)
};

const pt_br2_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const pt_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const ja_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長 (cm)`)
};

const zh_bmi_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身高（厘米）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_height_cm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_height_cm(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_height_cm", locale)
	if (locale === "en") return en_bmi_height_cm(inputs)
	if (locale === "es") return es_bmi_height_cm(inputs)
	if (locale === "de") return de_bmi_height_cm(inputs)
	if (locale === "nl") return nl_bmi_height_cm(inputs)
	if (locale === "fr") return fr_bmi_height_cm(inputs)
	if (locale === "it") return it_bmi_height_cm(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_height_cm(inputs)
	if (locale === "pt") return pt_bmi_height_cm(inputs)
	if (locale === "ja") return ja_bmi_height_cm(inputs)
	return zh_bmi_height_cm(inputs)
};